import { createContext } from "react";

const TopicsContext = createContext({});

export default TopicsContext;
